import React from 'react';

import BVReviews from 'components/consumer/PDP/BazaarVoice/BVReviews';
import usePdpFullVariantSku from '../state/pdpFullVariantSku/usePdpFullVariantSku';

const BVPDPCustomerPhotosUI = () => {
  const variantSku = usePdpFullVariantSku();

  return (
    <div
      className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14"
      id="PDPCustomerPhotos"
    >
      <BVReviews productId={variantSku} />
    </div>
  );
};

export default BVPDPCustomerPhotosUI;
